import React, { useEffect } from "react";
import { toAbsoluteUrl } from "../../../../Utils/_helpers";
import "../../../../Utils/_assets/sass/pages/error/error-5.scss";

export function Thankyou() {
  useEffect(() => {
    setTimeout(() => {
      window.location = "/";
    }, 3000);

    return () => {};
  }, []);
  return (
    <div className="d-flex flex-column flex-root">
      <div
        className="error error-5 d-flex flex-row-fluid bgi-size-cover bgi-position-center"
        style={{
          backgroundImage2: `url(${toAbsoluteUrl("/media/error/bg5.jpg")})`,
        }}
      >
        <div className="container d-flex flex-row-fluid flex-column text-center justify-content-md-center p-12">
          <h1 className="error-title2 font-weight-boldest22 text-info mt-10 mt-md-0 mb-12">
            Thank you
          </h1>
          <p className="font-weight-boldest display-4">
            FOR CHOOSING KNOWLARITY
          </p>
          <p className="font-size-h3">
            One of our representative shall connect with you.
            <br />
            You will be redirected to the home page in 3 seconds.
          </p>
        </div>
      </div>
    </div>
  );
}
